export default "__VITE_ASSET__d0e13512__"